/** Rendering scale: screen pixels per paper millimetre. */
export const PX_PER_MM = 4;

/** Standard 12-lead names, in clinical display order (mirrors the backend's set). */
export const ECG_LEAD_NAMES = [
  "I",
  "II",
  "III",
  "aVR",
  "aVL",
  "aVF",
  "V1",
  "V2",
  "V3",
  "V4",
  "V5",
  "V6",
];

/** 6-colour palette distinct from the Vivo blue grid line colour (#64BDE1). */
export const COMPARE_COLORS: readonly string[] = [
  "#2563eb",
  "#16a34a",
  "#dc2626",
  "#d97706",
  "#7c3aed",
  "#0891b2",
];
